export default function PartnershipSection() {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gray-800">
          信頼できるパートナーシップ
        </h2>
        
        <div className="mb-12">
          <img 
            src="https://readdy.ai/api/search-image?query=Professional%20business%20handshake%20between%20two%20executives%20in%20suits%2C%20modern%20office%20setting%2C%20partnership%20concept%2C%20trust%20and%20collaboration%2C%20corporate%20atmosphere%2C%20professional%20photography%20style%2C%20business%20success%20meeting&width=800&height=500&seq=handshake&orientation=landscape"
            alt="ビジネスパートナーとの握手"
            className="w-full max-w-2xl mx-auto rounded-lg shadow-lg object-cover"
          />
        </div>
        
        <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
          BIZ CHAINは、質の高い見込み客やビジネスパートナーを紹介できる完全審査制の経営者向けメンバーシップクラブです。 
          同じ経営者から生まれたサービスだからこそ、メリットのみが集約された夢のシステムを実現しています。
        </p>
      </div>
    </section>
  );
}